import {Arr, Num, Obj, OptEnum, OptStr, SchemaToType, Str} from '@shared/api/core/api_schema';

const AccountSchema = Obj({
  id: Str(),
  key: Str(),
});

export type Account = SchemaToType<typeof AccountSchema>;

const ProjectSettingsSchema = Obj({
  recentYear: Num(),
  minRecent: Num(),
  sexes: Arr(Str()),
});

const ProjectSchema = Obj({
  id: Str(),
  createdAt: Num(),
  updatedAt: Num(),
  lastSync: Num(),
  scores: Str(), // <name-key>/<score>/...
  settings: ProjectSettingsSchema,
  compare: OptStr(),
  code: OptStr(),
});

export type ProjectSex = 'boy' | 'girl';
export type ProjectSexes = ProjectSex[];

export type Project = SchemaToType<typeof ProjectSchema>;
export type ProjectSettings = SchemaToType<typeof ProjectSettingsSchema>;

export enum GptCacheStrategy {
  CACHE_ONLY = 'cache-only',
  FORCE_REFRESH = 'force-refresh',
  CACHE_THEN_REFRESH = 'cache-then-refresh',
}

export const APP_API = {
  '/create-account': {
    POST: {
      req: Obj({}),
      res: AccountSchema,
    },
  },
  '/auth-account': {
    POST: {
      req: AccountSchema,
      res: Obj({}),
    },
  },
  '/get-project': {
    GET: {
      req: Obj({code: Str()}),
      res: ProjectSchema,
    },
  },
  '/list-projects': {
    GET: {
      req: Obj({}),
      res: Arr(ProjectSchema),
    },
  },
  '/sync-project': {
    POST: {
      req: ProjectSchema,
      res: Obj({}),
    },
  },
  '/name-info': {
    GET: {
      req: Obj({name: Str(), cacheStrategy: OptEnum(GptCacheStrategy)}),
      res: Obj({markdown: OptStr()}),
    },
  },
};
